<template>
  <button class="clear-button">
    <span class="clear-button__icon">
      <CloseIcon />
    </span>
    <span class="clear-button__text"><slot /></span>
  </button>
</template>

<script>
  import CloseIcon from '@/assets/img/icons/close.svg?inline'

  export default {
    name: 'BaseClearButton',
    components: {
      CloseIcon
    }
  }
</script>

<style lang="scss" scoped>
  .clear-button {
    display: flex;
    padding: 0;
    font-family: "FavoritC", Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 1em;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;

    &__icon {
      display: block;
      width: 10px;
      height: 10px;
      margin-right: 9px;
      transform: translateY(-1px);

      path {
        transition: 0.3s;
      }
    }

    &__text {
      transition: 0.3s;
    }

    @include hover {
      .clear-button {
        &__icon {
          path {
            fill: $c-active;
          }
        }

        &__text {
          color: $c-active;
        }
      }
    }
  }
</style>
